import axios from "axios";
import React, { useEffect, useState } from "react";
import { Operacao } from "../../../Models/Cadastros/Operacao/Operacao";
import { useSnackbar } from "notistack";
import PopupBasePage from "../../../Components/Base/BasePopup";
import TabHeaderComponent from "../../../Components/Navigations/TabHeaderComponent";
import TabPanelComponent from "../../../Components/Navigations/TabPanelComponent";
import OperacaoDadosTab from "./OperacaoDadosTab";
import OperacaoIntegracaoTab from "./OperacaoIntegracaoTab";
import OperacaoServicoTab from "./OperacaoServicoTab";
import { FileUploadService } from "../../../Services/Bases/FileUploadService";

const OperacaoCadastroPopup = (props: any) => {
    const [tabValue, setTabValue] = React.useState(0);
    const [operacao, setOperacao] = useState<any>(new Operacao());
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        (async () => {
            if ((props.operacao?.id ?? 0) != 0) {
                setOperacao(props.operacao);
            }
        })();
    }, [props.operacao]);
    
    async function save() {
        try {
            const fileUploaded = await (new FileUploadService()).uploadImageAsync(operacao, 'logotipo_checklist');
            if (!fileUploaded){
                enqueueSnackbar('Erro ao salvar imagem!', { variant: 'error' });
                return;
            }

            let responseId: any = null;
            if (operacao?.id == null ||operacao?.id == 0 || operacao?.id == '') {
                let response = await axios.post('operacoes', operacao);
                responseId = response.data.id;
            }
            else {
                let response = await axios.put(`operacoes/${operacao.id}`, operacao);
                responseId = response.data.id;
            }

            enqueueSnackbar('Salvo com sucesso!', {variant: 'success'});
            let responseOperacao: any = await axios.get(`operacoes/${responseId}`);
            setOperacao(responseOperacao.data);
        } catch (error) {
            enqueueSnackbar('Erro ao salvar!', {variant: 'error'});
        }
        finally {
            document.body.style.cursor = "default";
        }
    }
    
    return (
        <PopupBasePage title="Operação" isOpen={props.isOpen} onClose={props.onClose} onClickFirstButtonPopupCallback={save} isPesquisa='false' confirmClose={true}>
            <div className="container">
                <div className="row">
                    <div className="align-all-left col-md-12 order-md-1">
                        <TabHeaderComponent setTabValueEventCallBack={setTabValue} label="Cadastro Operação" tabs={['Dados Principais', 'Serviços', 'Integração', 'Dados Adicionais', 'Aprovação Automática Check-list', 'Check-list Sistêmico', 'Check-list Questionário', 'PGR']} tab="operacao" />

                        <form className="needs-validation" id="formOperacaoDados">
                            <TabPanelComponent value={tabValue} index={0} tab="operacao" tabHeader="operacao">
                                <OperacaoDadosTab operacao={operacao} />
                            </TabPanelComponent>
                        </form>

                        <TabPanelComponent value={tabValue} index={1} tab="rota" tabHeader="operacao">
                            <OperacaoServicoTab operacao={operacao} />
                        </TabPanelComponent>

                        <TabPanelComponent value={tabValue} index={2} tab="operacao" tabHeader="operacao">
                            <OperacaoIntegracaoTab operacao={operacao} />
                        </TabPanelComponent>

                        <TabPanelComponent value={tabValue} index={3} tab="operacao" tabHeader="operacao">
                            {/* <OperacaoOperacoesTab operacao={operacao} /> */}
                        </TabPanelComponent>

                        <TabPanelComponent value={tabValue} index={4} tab="tecnologia" tabHeader="operacao">
                            {/* <OperacaoTecnologiasTab operacao={operacao} tecnologias={tecnologias} /> */}
                        </TabPanelComponent>

                        <TabPanelComponent value={tabValue} index={5} tab="painel" tabHeader="operacao">
                            {/* <OperacaoPaineis operacao={operacao} /> */}
                        </TabPanelComponent>
                    </div>
                </div>
            </div >
        </PopupBasePage>
    );
}

export default OperacaoCadastroPopup;